import React from "react";
import { Formik, Field, Form } from "formik";
import { object } from "yup";
import { DatePicker } from "../../components/datetime-picker.component";
import ConfirmDialog from "../../components/confirm.component";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";

const validationSchema = object().shape({});

class PlanDetailsForm extends React.Component {
  state = {
    showConfirm: false,
    hideAlert: true,
  };

  /**
   *
   */

  componentDidUpdate() {}

  /**
   *
   */

  showConfirm() {
    this.setState({ showConfirm: true });
  }

  closeConfirm() {
    this.setState({ showConfirm: false });
  }

  submissionConfirm(handleSubmit) {
    handleSubmit();
    this.closeConfirm();
  }

  /**
   *
   */

  render() {
    const { getForm, onSubmit, started_at, ended_at } = this.props;

    return (
      <>
        <Formik
          ref={(node) => getForm && getForm(node)}
          initialValues={{
            started_at: started_at || null,
            ended_at: ended_at || null,
          }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
          render={({ values, handleSubmit, setFieldValue }) => {
            return (
              <Grid item md={12}>
                <Form onSubmit={handleSubmit}>
                  <Grid container>
                    <Grid item md={3}>
                      <Field
                        name="started_at"
                        label="Data de subscrição do plano"
                        variant="outlined"
                        margin="normal"
                        component={DatePicker}
                        disabled="true"
                        fullWidth
                      />
                    </Grid>
                    <Grid
                      item
                      md={3}
                      onClick={() => {
                        this.setState({ hideAlert: false });
                      }}
                    >
                      <Field
                        name="ended_at"
                        label="Data limite do plano"
                        variant="outlined"
                        margin="normal"
                        onChange={(field, value) => {
                          setFieldValue(field, value);
                          this.setState({ hideAlert: false });
                        }}
                        value={"" + values.ended_at}
                        component={DatePicker}
                        fullWidth
                      />
                      <Typography
                        hidden={this.state.hideAlert}
                        color="secondary"
                        variant="body2"
                      >
                        Irá alterar o plano do cliente!
                      </Typography>
                    </Grid>
                  </Grid>
                </Form>

                <ConfirmDialog
                  open={this.state.showConfirm}
                  title={"Atenção"}
                  message={"Confirma a alteração do plano?"}
                  handleOk={() => this.submissionConfirm(handleSubmit)}
                  handleCancel={this.closeConfirm}
                ></ConfirmDialog>
              </Grid>
            );
          }}
        />

        <Button size="small" color="primary" onClick={() => this.showConfirm()}>
          Save
        </Button>
      </>
    );
  }
}

export default PlanDetailsForm;
